// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"cdd9113d","110":"596931a6","184":"0e36305f","386":"746a47d0","488":"3c7ec806","633":"a8d6c7dd","732":"64e3586a"}[chunkId] + ".chunk.js";
};